var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useCallback, useState } from 'react';
import { Box, Button, Link, MessageBox, NumberInputField, Typography, useToastService, } from '@lucidlink/uicore';
import { FormRoot, useFormRoot } from '@lucidlink/uicore/form-builder';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { appRoutes } from '#services';
import { useAwsContractCreation, } from './hooks';
import { awsContractFormSchema, customerIdRules, customerIdValidation, productCodeRules, productCodeValidation, } from './services/validation';
const AWS_SELLER_ID = '03105961661729617';
const buildAwsOfferUrl = (response, clientBaseUrl) => {
    const params = new URLSearchParams({
        sellerId: AWS_SELLER_ID,
        productCode: response.productCode,
        customerIdentifier: response.customerId,
        customerAWSAccountId: response.customerAWSAccountId,
    });
    const url = new URL(clientBaseUrl);
    url.pathname = appRoutes.awsOffer();
    url.search = params.toString();
    return url.toString();
};
const AwsContractCreationContent = () => {
    _react_refresh_temp_3();
    const [lastCreatedOfferUrl, setLastCreatedOfferUrl] = useState(null);
    const clientBaseUrl = useDependency(DEPENDENCY_KEYS.CLIENT_BASE_URL);
    const { errors, formData: { customerId, productCode }, } = useFormRoot();
    const { addToast } = useToastService();
    const handleSuccess = useCallback((data) => {
        const offerUrl = buildAwsOfferUrl(data, clientBaseUrl);
        setLastCreatedOfferUrl(offerUrl);
        addToast({
            content: {
                message: 'Successfully created mock AWS contract',
            },
            kind: 'positive',
            'data-testid': 'aws-contract-creation-success',
        });
    }, [addToast, clientBaseUrl]);
    const handleError = useCallback((error) => {
        addToast({
            content: {
                message: `Failed to create mock AWS contract: ${error instanceof Error ? error.message : 'Unknown error'}`,
            },
            kind: 'negative',
            'data-testid': 'aws-contract-creation-error',
        });
    }, [addToast]);
    const { mutation: { isPending: isCreating, mutate: createContract }, } = useAwsContractCreation({
        onSuccess: handleSuccess,
        onError: handleError,
    });
    const parsedFormData = awsContractFormSchema.safeParse({
        customerId,
        productCode,
    });
    const hasErrors = Object.keys(errors).length > 0;
    const isSubmitDisabled = !parsedFormData.success || hasErrors;
    const handleSubmit = () => {
        if (parsedFormData.success) {
            createContract(parsedFormData.data);
        }
    };
    return (_jsxs(Box, { gap: "m", orientation: "vertical", children: [_jsx(Typography, { color: "accent", kind: "h5", children: "AWS Contract Creation" }), lastCreatedOfferUrl ? (_jsxs(MessageBox, { "data-testid": "aws-offer-url-message", type: "positive", children: ["Last created offer:", ' ', _jsx(Link, { "data-testid": "aws-offer-url-link", inheritFontStyles: true, target: "_blank", to: lastCreatedOfferUrl, children: lastCreatedOfferUrl })] })) : null, _jsx(NumberInputField, { clientErrorMessage: "Enter a valid customer ID", "data-testid": "customer-id", disabled: isCreating, id: "customerId", label: "Customer ID", name: "customerId", placeholder: "Enter AWS customer ID...", rules: customerIdRules, validator: customerIdValidation }), _jsx(NumberInputField, { clientErrorMessage: "Enter a valid product code", "data-testid": "product-code", disabled: isCreating, id: "productCode", label: "Product Code", name: "productCode", placeholder: "Enter AWS product code...", rules: productCodeRules, validator: productCodeValidation }), _jsx(Box, { align: "center", gap: "sm", children: _jsx(Button, { "data-testid": "create-contract-button", disabled: isSubmitDisabled, isLoading: isCreating, kind: "secondary", onClick: handleSubmit, children: "Create Mock Contract" }) })] }));
};
_react_refresh_temp_1 = AwsContractCreationContent;
$RefreshReg$(_react_refresh_temp_1, "AwsContractCreationContent");
_react_refresh_temp_3(AwsContractCreationContent, "B0ig5HSc0L+HRZFAx49YXkCU9hI=", false, () => [useDependency, useFormRoot, useToastService, useAwsContractCreation]);
export const AwsContractCreation = () => {
    return (_jsx(FormRoot, { "data-testid": "aws-contract-creation-form", children: _jsx(AwsContractCreationContent, {}) }));
};
_react_refresh_temp_2 = AwsContractCreation;
$RefreshReg$(_react_refresh_temp_2, "AwsContractCreation");
